"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approverReviewSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.approverReviewSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'approvalDecisionCode',
        'approverLevelIndicator',
        'approverName',
        'approverTitleTypeCode',
        'approverUserID',
        'decisionTimestamp',
    ],
    properties: {
        approvalDecisionCode: {
            type: 'integer',
            enum: Object.values(constants_1.ApprovalDecisionCode),
            errorMessage: 'Should equate to a valid ApprovalDecisionCode enum value',
        },
        approvalOnBehalfOfOtherFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be true or false',
        },
        approverLevelIndicator: {
            type: 'integer',
            enum: Object.values(constants_1.ApprovalLevelIndicator),
        },
        approverName: {
            type: 'string',
            minLength: 1,
            maxLength: 41,
            errorMessage: 'Should have maximum of 41 characters',
        },
        approverTitleTypeCode: {
            type: 'integer',
            enum: Object.values(constants_1.TitleTypeCode),
            errorMessage: 'Should equate to a valid TitleTypeCode enum value',
        },
        approverUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUIDv4 format',
        },
        assignmentTimestamp: {
            type: ['string', 'null'],
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        decisionComment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'Should have maximum of 1000 characters',
        },
        decisionTimestamp: {
            type: 'string',
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        documentIDs: {
            type: ['array', 'null'],
            items: {
                type: 'string',
                format: 'uuid',
            },
            errorMessage: 'Should be an array of UUIDv4s or null',
        },
    },
    allOf: [
        {
            if: {
                required: ['approvalOnBehalfOfOtherFlag'],
                properties: {
                    approvalOnBehalfOfOtherFlag: {
                        // if flag is true, then documentIDs needs to be non null
                        enum: ['true', true],
                    },
                },
            },
            then: {
                required: ['documentIDs'],
                properties: {
                    documentIDs: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'uuid',
                        },
                        minItems: 1,
                        errorMessage: 'Should be an array of UUIDv4s with at least 1 item',
                    },
                },
            },
            errorMessage: constants_1.HbtValidationErrorCodes.HBT_ERR_APPROVE_BEHALF_OF_OTHER_PERSON_DOCUMENTID_REQUIRED.code + ": documentIDs is required if approvalOnBehalfOfOtherFlag is true",
        },
    ],
};
